import moment from 'moment';
import globals from '../../../globals/communityGlobals';
import {
  TREATMENT_INSTANCE_CANCEL_REQUEST,
  TREATMENT_INSTANCE_CANCEL_SUCCESS,
  TREATMENT_INSTANCE_CANCEL_FAILURE,
} from '../../constants/types';
import { HTTP_METHOD } from '../../constants/methods';

export function cancelTreatmentInstance(
  treatmentId,
  treatmentInstanceId,
  reasonId,
  cancelledBy,
  cancellingPartyId,
  cancellingName,
  cancellingNoticeDate,
  riskAssesment,
  dateAt,
  timeSlots,
) {
  return {
    types: [TREATMENT_INSTANCE_CANCEL_REQUEST, TREATMENT_INSTANCE_CANCEL_SUCCESS, TREATMENT_INSTANCE_CANCEL_FAILURE],
    buildCallParameters: () => ({
      method: HTTP_METHOD.POST,
      path: 'v1/command/CancelTreatmentInstance',
      data: {
        treatmentId,
        treatmentInstanceId,
        reasonId,
        cancelledBy,
        cancellingPartyId,
        cancellingName,
        cancellingNoticeDate,
        riskAssesment,
        dateAt: moment(dateAt).format(globals.dateFormats.localApiFormat),
        timeSlots,
      },
    }),
  };
}

export function bulkCancelTreatmentInstances(treatmentInstances) {
  return {
    types: [TREATMENT_INSTANCE_CANCEL_REQUEST, TREATMENT_INSTANCE_CANCEL_SUCCESS, TREATMENT_INSTANCE_CANCEL_FAILURE],
    buildCallParameters: () => ({
      method: HTTP_METHOD.POST,
      path: 'v1/command/BulkCancelTreatmentInstances',
      data: { treatmentInstances },
    }),
  };
}
